import graphqlResource, { GraphqlResource } from 'modules/core/graphql-resource';
import type { StatisticResponseDto } from 'modules/main/domain/types/response-dto';

export class MainPageRepository {
  constructor(private readonly graphql: GraphqlResource) {}

  public async getStatistics(id: number): Promise<StatisticResponseDto> {
    const query = `#graphql
    query getStatistics($id: Int!) {
      getTournamentStatistics(tournamentId: $id) {
        championships
        finishedChampionships
        activeChampionships
        upcomingChampionships
        players
        teams
        acceptedApplicationsPlayers
        acceptedApplicationsTeams
        topTeams {
          team {
            id
            name
            emblem {
              externalUrl
            }
          }
          matchCount
        }
        topShooters {
          user {
            id
            name
            surname
            photo {
              externalUrl
            }
          }
          goals
        }
      }
    }
    `;

    const response = await this.graphql.query<{
      data: { getTournamentStatistics: StatisticResponseDto };
    }>(query, { id });

    return response.data.data.getTournamentStatistics;
  }
}

const mainPageRepository = new MainPageRepository(graphqlResource);

export default mainPageRepository;
